import React from 'react'

import { Radio, RadioProps } from '@ui/components/Radio'

import { RadioGroup } from '@shared/components/RadioGroup/RadioGroup'

interface Props {
  name: string
  options?: RadioProps[]
  value?: string | number
  onChange?: (value: any) => void
}

const RadioGroupBase: React.FC<Props> = (props) => {
  const { name, options, value, onChange } = props

  return (
    <RadioGroup value={value} name={name} onChange={onChange}>
      {options?.map((option) => (
        <Radio
          key={String(option.value ?? option.id ?? option.label ?? '')}
          {...option}
          name={name}
        />
      ))}
    </RadioGroup>
  )
}

export const ModalBodyInputRadio = Object.assign(RadioGroupBase)
